export default __webpack_public_path__ + "static/media/ScrollDown1.3cf6cc2a.gif";